import script from "./homeTabs.vue?vue&type=script&setup=true&name=home-Tabs&lang=js"
export * from "./homeTabs.vue?vue&type=script&setup=true&name=home-Tabs&lang=js"

import "./homeTabs.vue?vue&type=style&index=0&id=4945721e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4945721e"]])

export default __exports__